import { Link } from "react-router-dom";

export default function Fundraise() {
    return (
        <>
            <section className="fundraise-1-section">
                <div className="auto-container">
                    <div className="section_heading text-center mb_90">
                        {/* <span className="section_heading_title_small">Fund Raise</span> */}
                        <h2 className="section_heading_title_big">We’re Take Care of Your Problems <br /> Carefully</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="fundraise-1-block wow fadeInLeft" data-wow-delay=".2s" data-wow-duration=".8s">
                                <div className="fundraise-1-image">
                                    <img src="assets/images/Fundraise/fundraise01.jpg" alt="" />
                                    <div className="fundraise-1-link-btn">
                                        <Link href="/" className="btn-1 btn-small">Read More<span></span></Link>
                                    </div>
                                </div>
                                <div className="fundraise-1-content">
                                    <h4 className="fundraise-1-title">Specialist Nursing Care</h4>
                                    <p className="fundraise-1-text">We offer specialist nursing care delivered by registered or enrolled nurses to support individuals with complex health needs or chronic medical conditions. Our nurses provide clinical and personal care services in the community to promote health, wellbeing, and independence.</p>
                                    <div className="fundraise-1-skill-item">
                                        <div className="fundraise-1-skill-bar">
                                            <div style={{background:"pink"}} className="progressbar-1-outer">

                                            </div>
                                        </div>
                                    </div>
                                
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="fundraise-1-block wow fadeInLeft" >
                                <div className="fundraise-1-image">
                                    <img src="assets/images/Fundraise/fundraise02.jpg" alt="" />
                                    <div className="fundraise-1-link-btn">
                                        <Link href="/" className="btn-1 btn-small">Read More<span></span></Link>
                                    </div>
                                </div>
                                <div className="fundraise-1-content">
                                    <h4 className="fundraise-1-title">Provide Home Visit Care</h4>
                                    <p className="fundraise-1-text">Our team delivers personal and clinical care directly in your home, helping you with daily activities, household tasks, and health support. These services are designed to help you live safely, comfortably, and independently in your own space.</p>
                                    <div className="fundraise-1-skill-item">
                                        <div className="fundraise-1-skill-bar">
                                            <div style={{background:"pink"}} className="progressbar-1-outer">
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fundraise-1-price d-flex align-items-center justify-content-between">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="fundraise-1-block wow fadeInLeft" >
                                <div className="fundraise-1-image">
                                    <img src="assets/images/Fundraise/fundraise03.jpg" alt="" />
                                    <div className="fundraise-1-link-btn">
                                        <Link href="/" className="btn-1 btn-small">Read More<span></span></Link>
                                    </div>
                                </div>
                                <div className="fundraise-1-content">
                                    <h4 className="fundraise-1-title">Relatives Accommodation</h4>
                                    <p className="fundraise-1-text">We understand the importance of family support. That's why we offer convenient accommodation options for relatives staying close to participants during their care journey, ensuring comfort and peace of mind for both clients and their loved ones.</p>
                                    <div className="fundraise-1-skill-item">
                                        <div className="fundraise-1-skill-bar">
                                            <div style={{background:"pink"}} className="progressbar-1-outer">
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fundraise-1-price d-flex align-items-center justify-content-between">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
